module.exports = "/dist/assets/images/expand.svg";